import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <img
        src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20content%20streaming%20platform%20atmosphere%20with%20warm%20cinematic%20lighting%2C%20abstract%20geometric%20elements%20in%20soft%20golden%20and%20cream%20tones%2C%20elegant%20curved%20lines%2C%20Japanese%20and%20Korean%20aesthetic%20fusion%2C%20clean%20professional%20design%2C%20warm%20gradient%20background%20with%20subtle%20texture&width=1920&height=1080&seq=hero-bg-2024&orientation=landscape"
        alt="aaa日韩正版内容平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 leading-tight mb-4 md:mb-6">
            aaa日韩官方入口
            <br />
            <span className="text-primary-300">正版授权平台</span>
          </h1>
          <p className="text-sm md:text-lg text-background-50/80 max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
            aaa日韩是您探索日韩优质内容的首选平台，汇聚海量日韩正版资源，
            高清流畅体验，多终端同步播放，每日持续更新，满足您对aaa日韩全方位的内容需求。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <Link
              to="/category/riju"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm md:text-base whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              立即免费体验
            </Link>
            <Link
              to="/about"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-background-50/15 text-background-50 font-medium text-sm md:text-base whitespace-nowrap backdrop-blur-sm hover:bg-background-50/25 transition-colors cursor-pointer border border-background-50/30"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}